// The latest call for an element wins: it cancels that element's pending fade
// (or blur), so a late timer can't bring back something hidden since. 0 ms
// runs straight away.
export class Effects {
  static #fadeTimers = new WeakMap();
  static #blurTimers = new WeakMap();

  static delayedFadeIn(element, milliseconds = 0) {
    if (!element) {
      return;
    }

    if (milliseconds > 0) {
      element.classList.add("fade-out");
    }

    Effects.#schedule(Effects.#fadeTimers, element, milliseconds, () => {
      element.classList.remove("d-none", "fade-out");
      element.classList.add("fade-in");
    });
  }

  static delayedFadeOut(element, milliseconds = 0) {
    if (!element) {
      return;
    }

    Effects.#schedule(Effects.#fadeTimers, element, milliseconds, () => {
      element.classList.add("d-none", "fade-out");
      element.classList.remove("fade-in");
    });
  }

  static delayedBlurIn(element, milliseconds = 0) {
    if (!element) {
      return;
    }

    Effects.#schedule(Effects.#blurTimers, element, milliseconds, () => {
      element.classList.remove("blur-out");
      element.classList.add("blur-in");
    });
  }

  static delayedBlurOut(element, milliseconds = 0) {
    if (!element) {
      return;
    }

    Effects.#schedule(Effects.#blurTimers, element, milliseconds, () => {
      element.classList.remove("blur-in");
      element.classList.add("blur-out");
    });
  }

  // For scrollIntoView / scrollTo: no smooth scrolling for users who ask for less motion
  static scrollBehavior() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
  }

  static #schedule(timers, element, milliseconds, action) {
    clearTimeout(timers.get(element));
    timers.delete(element);

    if (milliseconds > 0) {
      timers.set(element, setTimeout(() => {
        timers.delete(element);
        action();
      }, milliseconds));
    } else {
      action();
    }
  }
}
